import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonInput, IonModal } from '@ionic/angular';
import { ColumnMode, SelectionType, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { etkezesHaviOsszeg } from 'src/app/util/etkezes-ar';

@Component({
  selector: 'app-adofolyoszamla',
  templateUrl: './adofolyoszamla.component.html',
  styleUrls: ['./adofolyoszamla.component.scss'],
})
export class AdofolyoszamlaComponent implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;

  sajatIntezmeny
  intezmeny = 2
  dolgozok = 0
  tanulok = 0
  felulet = 0
  import = 0
  besorolas = 0
  enaplo = 0
  dokumentumok = 0
  adatszolg = 0
  penzugy = 0
  modulok = 0
  munkatarssorok = [];
  datetime
  alkalmazk
  alkalmazv

  selected = [];
  telepules
  allampolgar
  orszag
  SelectionType = SelectionType;
  allomany
  csoport
  @ViewChild("uzenetmodal") modal: IonModal;
  @ViewChild("bizonylatmodal") bizmodal: IonModal;
  @ViewChild("tetelmodal") tetelmodal: IonModal;
  segment = "3"
  bizonylattipus = 0;
  bizonylatok = ["-", "számla", "előleg számla", "díjbekérő", "nyugta", "árajánlat", "szállítólevél", "teljesítésigazolás", "stornószámla"]
  invoices

  portControl: FormControl;
  form: FormGroup;
  egyenleg: any = {}
  csegyenleg
  csegyenlegid
  kovetel
  kovetelnullaz
  jovair
  tetelek: any = []
  tetel: FormGroup;
  ebedusers = []
  loginmode
  userMetadata
  tombok


  elsoMezo
  szamlaTukor=[]
  folyoszlaosszeg=0

protected readonly parseFloat = parseFloat;
  folyoszamla={
    "resultMessage": "0 - []",
    "resultCode": "SIKERES",
    "tetelesAdoszamla": {
        "bhtlUzenet": null,
        "kodLista": [
            {
                "nev": "Pénzforgalmi tétel típusának megnevezése:",
                "kodListaElem": [
                    {
                        "kod": "01",
                        "ertek": "befizetés"
                    },
                    {
                        "kod": "03",
                        "ertek": "átvezetés másik adónemről"
                    },
                    {
                        "kod": "04",
                        "ertek": "átvezetés másik adónemre"
                    }
                ]
            },
            {
                "nev": "Elszámolási számla jelző értelmezése:",
                "kodListaElem": [
                    {
                        "kod": "1",
                        "ertek": "104040275050565649491010"
                    },
                    {
                        "kod": "2",
                        "ertek": "1003200001076356"
                    },
                    {
                        "kod": "3",
                        "ertek": "1003200001076868"
                    }
                ]
            }
        ],
        "adozo": {
            "adoalanyAzonosito": "14608278-2-13",
            "nev": "TAXI-TAX KERESKEDELMI ÉS SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG",
            "cim": "2120 DUNAKESZI ADY ENDRE UTCA 12.",
            "konyvelesiAzonosito": "14608278",
            "idoszak": "2025.01.01-2025.11.07",
            "lekerdezesIdopontja": "2025-11-07T18:34:56",
            "vpid": null
        },
        "mindOsszesen": {
            "tartozas": "79000",
            "tulfizetes": "122200",
            "egyenleg": {
                "osszeg": "43200",
                "minosites": "TULFIZETES"
            },
            "letetiEgyenleg": {
                "osszeg": "0",
                "minosites": "EGYENLEG"
            }
        },
        "adonem": [
            {
                "kod": "104",
                "megnevezes": "Általános forgalmi adó",
                "szamlaszam": "Adónem számlaszáma: 10032000-01076868",
                "kotelezettsegOsszesen": "1202000",
                "penzforgalomOsszesen": "-1123000",
                "konyvelesreVaroOsszesen": "0",
                "konyvelesreVaroTetel": [],
                "tetel": [
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-01-01",
                        "kotelezettseg": "0",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Nyitóegyenleg",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-01-23",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-89000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-01-20",
                        "kotelezettseg": "89000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-02-24",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-84000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-02-20",
                        "kotelezettseg": "84000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-03-24",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-196000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-03-20",
                        "kotelezettseg": "196000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-05-05",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-3000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-04-22",
                        "kotelezettseg": "3000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-05-20",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-196000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "1003200001076356",
                        "ellenszamlaKod": "2",
                        "esedekessegiDatum": "2025-05-20",
                        "kotelezettseg": "196000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-06-24",
                        "tipus": "03",
                        "tipusKodolatlan": "átvezetés másik adónemről",
                        "penzforgalom": {
                            "osszeg": "-244000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-06-20",
                        "kotelezettseg": "190000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-07-23",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-39000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-07-21",
                        "kotelezettseg": "93000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-08-21",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-110000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-08-21",
                        "kotelezettseg": "110000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-09-23",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-162000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-09-22",
                        "kotelezettseg": "5000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "65-ös bev. önell.",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-09-22",
                        "kotelezettseg": "157000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-10-20",
                        "kotelezettseg": "79000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    }
                ],
                "konyvelesreUzenet": {
                    "kod": "001",
                    "szoveg": "Jelenleg nincs könyvelésre váró pénzforgalmi tétel."
                },
                "adonemEgyenleg": {
                    "osszeg": "79000",
                    "minosites": "TARTOZAS"
                }
            },
            {
                "kod": "138",
                "megnevezes": "Késedelmi pótlék",
                "szamlaszam": "Adónem számlaszáma: 10032000-01076985",
                "kotelezettsegOsszesen": "6000",
                "penzforgalomOsszesen": "-6000",
                "konyvelesreVaroOsszesen": "0",
                "konyvelesreVaroTetel": [],
                "tetel": [
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-03-31",
                        "kotelezettseg": "6000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "2024. évi késedelmi pótlék",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-05-05",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-6000",
                            "deviza": null
                        }
                    }
                ],
                "konyvelesreUzenet": {
                    "kod": "001",
                    "szoveg": "Jelenleg nincs könyvelésre váró pénzforgalmi tétel."
                },
                "adonemEgyenleg": {
                    "osszeg": "0",
                    "minosites": "EGYENLEG"
                }
            },
            {
                "kod": "215",
                "megnevezes": "Bírság, mulasztási bírság és önellenőrzési pótlék",
                "szamlaszam": "Adónem számlaszáma: 10032000-01076301",
                "kotelezettsegOsszesen": "0",
                "penzforgalomOsszesen": "0",
                "konyvelesreVaroOsszesen": "0",
                "konyvelesreVaroTetel": [],
                "tetel": [
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-01-01",
                        "kotelezettseg": "0",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Nyitóegyenleg",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    }
                ],
                "konyvelesreUzenet": {
                    "kod": "001",
                    "szoveg": "Jelenleg nincs könyvelésre váró pénzforgalmi tétel."
                },
                "adonemEgyenleg": {
                    "osszeg": "0",
                    "minosites": "EGYENLEG"
                }
            },
            {
                "kod": "241",
                "megnevezes": "Cégautóadó",
                "szamlaszam": "Adónem számlaszáma: 10032000-01076167",
                "kotelezettsegOsszesen": "0",
                "penzforgalomOsszesen": "0",
                "konyvelesreVaroOsszesen": "0",
                "konyvelesreVaroTetel": [],
                "tetel": [
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-01-01",
                        "kotelezettseg": "0",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Nyitóegyenleg",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    }
                ],
                "konyvelesreUzenet": {
                    "kod": "001",
                    "szoveg": "Jelenleg nincs könyvelésre váró pénzforgalmi tétel."
                },
                "adonemEgyenleg": {
                    "osszeg": "0",
                    "minosites": "EGYENLEG"
                }
            },
            {
                "kod": "289",
                "megnevezes": "Kisvállalati adó",
                "szamlaszam": "Adónem számlaszáma: 10032000-01076356",
                "kotelezettsegOsszesen": "-228000",
                "penzforgalomOsszesen": "228000",
                "konyvelesreVaroOsszesen": "0",
                "konyvelesreVaroTetel": [],
                "tetel": [
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-01-01",
                        "kotelezettseg": "-81000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Nyitóegyenleg",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-01-06",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-16000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "1003200001076868",
                        "ellenszamlaKod": "3",
                        "esedekessegiDatum": "2025-01-20",
                        "kotelezettseg": "49000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "KIVA előleg alap/önell.",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-06-24",
                        "tipus": "04",
                        "tipusKodolatlan": "átvezetés másik adónemre",
                        "penzforgalom": {
                            "osszeg": "244000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-04-22",
                        "kotelezettseg": "0",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "KIVA előleg alap/önell.",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-06-02",
                        "kotelezettseg": "-196000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "KIVA éves bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-07-21",
                        "kotelezettseg": "0",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "KIVA előleg alap/önell.",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-10-20",
                        "kotelezettseg": "0",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "KIVA előleg alap/önell.",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    }
                ],
                "konyvelesreUzenet": {
                    "kod": "001",
                    "szoveg": "Jelenleg nincs könyvelésre váró pénzforgalmi tétel."
                },
                "adonemEgyenleg": {
                    "osszeg": "0",
                    "minosites": "EGYENLEG"
                }
            },
            {
                "kod": "290",
                "megnevezes": "Személyi jövedelemadó (magánszemélyektől levont)",
                "szamlaszam": "Adónem számlaszáma: 10032000-06055950",
                "kotelezettsegOsszesen": "837000",
                "penzforgalomOsszesen": "-925000",
                "konyvelesreVaroOsszesen": "0",
                "konyvelesreVaroTetel": [],
                "tetel": [
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-01-01",
                        "kotelezettseg": "2000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Nyitóegyenleg",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-01-06",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-84000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-01-13",
                        "kotelezettseg": "85000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-01-30",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-3000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-02-12",
                        "kotelezettseg": "87000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-02-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-87000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-03-12",
                        "kotelezettseg": "87000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-03-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-87000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-04-14",
                        "kotelezettseg": "87000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-04-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-87000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-05-12",
                        "kotelezettseg": "87000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-05-05",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-87000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-06-12",
                        "kotelezettseg": "87000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-06-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-87000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-07-14",
                        "kotelezettseg": "87000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-07-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-87000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-08-12",
                        "kotelezettseg": "87000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-08-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-87000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-09-12",
                        "kotelezettseg": "71000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-09-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-87000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-10-13",
                        "kotelezettseg": "70000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-10-06",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-71000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": null,
                        "kotelezettseg": null,
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": null,
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-11-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-71000",
                            "deviza": null
                        }
                    }
                ],
                "konyvelesreUzenet": {
                    "kod": "001",
                    "szoveg": "Jelenleg nincs könyvelésre váró pénzforgalmi tétel."
                },
                "adonemEgyenleg": {
                    "osszeg": "88000",
                    "minosites": "TULFIZETES"
                }
            },
            {
                "kod": "407",
                "megnevezes": "Biztosítottaktól levont társadalombiztosítási járulék",
                "szamlaszam": "Adónem számlaszáma: 10032000-06055819",
                "kotelezettsegOsszesen": "330000",
                "penzforgalomOsszesen": "-364200",
                "konyvelesreVaroOsszesen": "0",
                "konyvelesreVaroTetel": [],
                "tetel": [
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-01-01",
                        "kotelezettseg": "0",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Nyitóegyenleg",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-01-06",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-30000",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-01-13",
                        "kotelezettseg": "30000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-02-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-02-12",
                        "kotelezettseg": "33000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-03-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-03-12",
                        "kotelezettseg": "34000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-04-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-04-14",
                        "kotelezettseg": "33000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-05-05",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-05-12",
                        "kotelezettseg": "33000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-06-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-06-12",
                        "kotelezettseg": "34000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-07-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-07-14",
                        "kotelezettseg": "33000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-07-23",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-1200",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-08-12",
                        "kotelezettseg": "33000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-08-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-09-12",
                        "kotelezettseg": "33000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-09-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-10-13",
                        "kotelezettseg": "34000",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "08-as havi bevallás",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-10-06",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": null,
                        "kotelezettseg": null,
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": null,
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-11-04",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-33300",
                            "deviza": null
                        }
                    }
                ],
                "konyvelesreUzenet": {
                    "kod": "001",
                    "szoveg": "Jelenleg nincs könyvelésre váró pénzforgalmi tétel."
                },
                "adonemEgyenleg": {
                    "osszeg": "34200",
                    "minosites": "TULFIZETES"
                }
            },
            {
                "kod": "410",
                "megnevezes": "NAV Belföldi gépjárműadó bevételi számla",
                "szamlaszam": "Adónem számlaszáma: 10032000-01079160",
                "kotelezettsegOsszesen": "21024",
                "penzforgalomOsszesen": "-21024",
                "konyvelesreVaroOsszesen": "0",
                "konyvelesreVaroTetel": [],
                "tetel": [
                    {
                        "aladonem": null,
                        "ellenszamla": "104040275050565649491010",
                        "ellenszamlaKod": "1",
                        "esedekessegiDatum": "2025-01-01",
                        "kotelezettseg": "-3084",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Nyitóegyenleg",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": "2025-05-05",
                        "tipus": "01",
                        "tipusKodolatlan": "befizetés",
                        "penzforgalom": {
                            "osszeg": "-21024",
                            "deviza": null
                        }
                    },
                    {
                        "aladonem": null,
                        "ellenszamla": null,
                        "ellenszamlaKod": null,
                        "esedekessegiDatum": "2025-04-15",
                        "kotelezettseg": "24108",
                        "kotelezettsegAtvezetveForras": null,
                        "kotelezettsegAtvezetveForrasKod": null,
                        "megnevezes": "Gépjárműadó (RHE017)",
                        "penzforgalomAtvezetveForras": null,
                        "penzforgalomAtvezetveForrasKod": null,
                        "teljesitesiDatum": null,
                        "tipus": null,
                        "tipusKodolatlan": null,
                        "penzforgalom": null
                    }
                ],
                "konyvelesreUzenet": {
                    "kod": "001",
                    "szoveg": "Jelenleg nincs könyvelésre váró pénzforgalmi tétel."
                },
                "adonemEgyenleg": {
                    "osszeg": "0",
                    "minosites": "EGYENLEG"
                }
            }
        ]
    }
}

  constructor(private http: HttpClient, private data: DataService,
    private formBuilder: FormBuilder) {

    this.portControl = this.formBuilder.control(
      { id: 142, nev: "magyar" },
      Validators.required
    );
    this.form = this.formBuilder.group({
      anyanyelv: this.portControl,
      allampolgar1: this.portControl,
      allampolgar2: this.portControl,
      alkalmazk: new FormControl("", Validators.required),
      alkalmazv: new FormControl(""),
      orszag: new FormControl({ id: 142, nev: "Magyarország" }, Validators.required)
    });
    this.tetel = this.formBuilder.group({
      tipus: new FormControl("", Validators.required),
      nev: new FormControl("", Validators.required),
      osszeg: new FormControl("", Validators.required),
      szamla: new FormControl(0),
      alrendszer: new FormControl(""),
      ev: new FormControl(""),
      honap: new FormControl(""),
      koveteles: new FormControl(""),
      dijbekero: new FormControl(false),
      biztomb: new FormControl(""),
    });
  }
  async tipusValt() {
    if (this.tetel.value.tipus == "Követelés alrendszerből" || this.tetel.value.tipus == "Jóváírás alrendszerből") {

      this.tetel.patchValue({ nev: this.tetel.value.alrendszer + " - " + this.tetel.value.honap + ". hónap" })

    }
  }
  async getAdatFromAlrendszer() {
    await this.data.showLoading("Adatok betöltése...")
    let body = []
    this.ebedusers = []
    body = this.csegyenleg.users.filter((item: any) => item.type === "tanulo").map((item: any) => ({ oktazon: item.id }));
    this.ebedusers = body
    console.log(body)
    this.http
      .post(
        '/api/etkezes/tanulo/' + this.tetel.value.ev + '/' + this.tetel.value.honap + '/' + this.sajatIntezmeny.intezmenyId,//'https://idp.zenit.cronom.it/admin/realms/master/users?q=title:oktató',
        body
      )
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.data.hideLoading()
          let vegosszeg = 0;

          response.forEach((element) => {
            element.adatok = JSON.parse("[" + element.adatok + "]");
            try { element.etkezes_hely_adatok = JSON.parse(element.etkezes_hely_adatok); } catch (e) { }
            vegosszeg += etkezesHaviOsszeg(element);
          });
          this.tetel.patchValue({ osszeg: vegosszeg })
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.data.hideLoading()
        },
      });

  }
  async getAdatFromKoveteles(kov) {
    kov = kov.detail.value
    this.tetel.patchValue({ alrendszer: kov.alrendszer, nev: kov.nev + " jóváírás", osszeg: kov.osszeg })
  }
  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.loginmode = (await this.data.getFromStorage("loginmode"))

    if (this.loginmode == 'gondviselo') {
      this.userMetadata = await this.data.getFromStorage("userMetadata")
      //this.egyenleg = JSON.parse((await this.data.getFromStorage("egyenleg")))
      //console.log(this.userMetadata.username)
      this.csegyenlegid = 0
      await this.getEgyenlegReszletes(this.userMetadata.username)
      this.getCsaladEgyenleg(this.userMetadata.username)
    } else {
      await this.getEgyenleg()
    }

  
    //this.getTomb()
    //this.egyenleg = JSON.parse((await this.data.getFromStorage("egyenleg")))
    //if(this.egyenleg.tetelek) this.tetelek = JSON.parse(this.egyenleg.tetelek)

    //this.getAllomany();
  }
  async getTomb() {
    await this.http
      .get(
        '/api/szamla/tombok/'+ this.sajatIntezmeny.intezmenyId,
        {

        }
      )
      .subscribe({
        next: (response) => {
          this.tombok = response
          //console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }
  async getEgyenleg() {
    await this.http
      .get(
        '/api/billiard/szamlatukor',
        {

        }
      )
      .subscribe({
        next: (response:any) => {
          this.szamlaTukor = response.filter(d=>d.csoport != d.fokonyvi_szam)
          //console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  
    await this.http
      .get(
        '/api/egyenleg',
        {

        }
      )
      .subscribe({
        next: (response) => {
          this.egyenleg = response
          //console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }
  async getEgyenlegReszletes(id) {
    await this.http
      .get(
        '/api/egyenlegreszletes/' + id,
        {

        }
      )
      .subscribe({
        next: (response) => {
          this.egyenleg = response
          this.csegyenleg = this.egyenleg
          this.csegyenleg.csalad = this.egyenleg.csalad
            this.csegyenleg.users = JSON.parse(this.egyenleg.csalad_reszletek)
            if (!this.csegyenleg.egyenleg) this.csegyenleg.egyenleg = 0
            this.kovetel =  JSON.parse(this.egyenleg.tetelek).filter(s => s.osszeg >= 0)
            this.kovetelnullaz =  JSON.parse(this.egyenleg.tetelek).filter(s => s.osszeg >= 0 && s.kapcsolat == null)
            this.jovair =  JSON.parse(this.egyenleg.tetelek).filter(s => s.osszeg < 0)
          //this.egyenleg[0].csalad_reszletek = JSON.parse(this.egyenleg[0].csalad_reszletek)
          //console.log(this.egyenleg)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }
  async getCsaladEgyenleg(id, bizmodal = null) {
    await this.http
      .get(
        '/api/egyenleg/' + id,
        {

        }
      )
      .subscribe({
        next: async (response: any) => {
          response.tetelek = JSON.parse(response.tetelek)
          this.csegyenleg = response
          if (this.loginmode != 'gondviselo') {
            this.csegyenleg.csalad = this.egyenleg[this.csegyenlegid].csalad
            this.csegyenleg.users = JSON.parse(this.egyenleg[this.csegyenlegid].csalad_reszletek)
            if (!this.csegyenleg.egyenleg) this.csegyenleg.egyenleg = 0
            this.kovetel = response.tetelek.filter(s => s.osszeg >= 0)
            this.kovetelnullaz = response.tetelek.filter(s => s.osszeg >= 0 && s.kapcsolat == null)
            this.jovair = response.tetelek.filter(s => s.osszeg < 0)
            console.log(response)
          } else {
            //this.csegyenleg = this.egyenleg[0]
            
          }
          await this.data.setStorage("csalad", response)
          if (bizmodal == "bizmodal") this.bizmodal.present();
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        }
      })
  }



  getRowClass = (row) => {
    return {
      'row-color-blue': row.osszeg >= 0,
      'row-color-green': row.osszeg < 0
    };
  }
  getCellClass = (row) => {
    return {
      'row-color-blue': row.osszeg >= 0,
      'row-color-green': row.osszeg < 0
    };
  }

  initModal(id, i) {

    this.csegyenlegid = i
    this.getCsaladEgyenleg(id)
    //this.form.patchValue({orszag:{id:1,nev:"Afganisztán"}})
    this.modal.present();
  }
  initModal2(id, i, type = null) {
    console.log(id)
    if (type) this.tetel.patchValue({ tipus: type });
    //this.tetel.patchValue({ev:moment().format("YYYY"),honap:"1",alrendszer:"Étkezés"})

    this.csegyenlegid = i
    this.getCsaladEgyenleg(id)
    //this.form.patchValue({orszag:{id:1,nev:"Afganisztán"}})
    this.tetelmodal.present();
  }
  async initModal3(id, i) {

    this.csegyenlegid = i
    await this.getCsaladEgyenleg(id, "bizmodal")
    //this.form.patchValue({orszag:{id:1,nev:"Afganisztán"}})

  }
  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getEletut() {
    this.http
      .get(
        'https://merfoldkovek.oh.gov.hu/api/User/Timeline',
        {

        }
      )
      .subscribe({
        next: (response) => {
          //this.allomany = response
          console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          /*
          {
              "allapot": "NincsMegFeliratkozva",
              "formatumVerzio": 1,
              "generalva": "0001-01-01T00:00:00",
              "adatok": null,
              "adatAllapot": "OsszeallitasAlatt",
              "leiratkozasOka": "Oktazonvaltozas",
              "leiratkozva": null,
              "letrehozva": null,
              "megtekintveUgyintezokent": false,
              "ugyintezoOktazon": null,
              "isSucceeded": true,
              "reasonOfFail": null,
              "muveletAzonosito": "67155014-3c68-47cc-802d-a68aee09ce1c",
              "errorCode": 0,
              "errorCodeString": "0000",
              "time": "2025-01-17T16:35:45.4874766+01:00"
          } */
        },
      });
  }

  getAllomany() {
    let headers = {
      intezmeny: this.sajatIntezmeny.intezmenyId
    }

    this.http
      .get(
        '/api/nyilvantartas/szulo/' + this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allomany = response
          console.log(this.allomany)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/csoport/' + this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.csoport = response
          console.log(this.csoport)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/telepules/hu',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.telepules = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/allampolgarsag',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allampolgar = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/orszagok',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.orszag = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }



  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
  cancel2() {
    this.tetelmodal.dismiss(null, 'cancel');
    this.tetel.reset();
  }
  cancel3() {
    this.bizmodal.dismiss(null, 'cancel');
  }

  confirm(mode) {
    this.bizmodal.dismiss(null, 'ok');
    this.bizonylattipus = mode;
    this.modal.present();
  }
  confirm2() {
    this.tetelmodal.dismiss(null, 'ok');
    let body = { kapcsolat: this.tetel.value.koveteles?.id ? '"' + this.tetel.value.koveteles?.id + '"' : null, alrendszer: this.tetel.value.alrendszer, ev: this.tetel.value.ev, honap: this.tetel.value.honap, users: this.ebedusers, nev: this.tetel.value.nev, osszeg: this.tetel.value.tipus == "Követelés" || this.tetel.value.tipus == "Követelés alrendszerből" ? this.tetel.value.osszeg : -this.tetel.value.osszeg, csalad: this.egyenleg[this.csegyenlegid].csalad, date: moment().format("YYYY-MM-DD HH:mm:ss"), szamla: null }

    this.http.post("/api/egyenleg/kiir", body).subscribe((res: any) => {
      //console.log(res)
      if (this.tetel.value.dijbekero == true) this.bizonylatCreate(this.tetel.value, res.id)
      this.tetel.reset();
      this.getEgyenleg();
      this.getCsaladEgyenleg(this.csegyenlegid);
      this.data.sendToast("Tétel kiírva!", "success")
    })

  }

  fotipusvalt(e) {

  }


  async bizonylatCreate(tetelek, tetelid) {
    await this.data.showLoading("Bizonylat létrehozása...");
    let users = this.csegyenleg.users.filter((item: any) => item.type == "szulo");
    const body = {
      bizonylattipus: tetelek.tipus.indexOf("Jóváírás")!=-1 ? 1 : 3,
      tetelek: [{ "id": tetelid, "nev": tetelek.nev, "alrendszer": tetelek.alrendszer || "", "osszeg": tetelek.osszeg, "afa": "AAM", "mennyiseg": "1", "megyseg": "hó" }],
      form: { kapja: users[0]?.id, osszesen: tetelek.osszeg, biztomb: tetelek.biztomb, fizmod: tetelek.tipus.indexOf("Jóváírás")!=-1 ? "Készpénz" : "Bankkártya" },
      intezmeny: this.sajatIntezmeny
    }
    this.http
      .post(
        '/api/szamla/create',
        body
      )
      .subscribe({
        next: (response: any) => {
          this.data.hideLoading();
          this.data.sendToast("Bizonylat létrehozva!", "success")
          this.http
            .get(
              '/api/nav/geninvoice/' + response[0]?.id + '/' + this.sajatIntezmeny.intezmenyId
            )
            .subscribe({
              next: (response2) => {
                this.data.sendToast("Bizonylat generálása sikeres!", "success")
              },
              error: (error) => {
                console.error('Error fetching data:', error);
                //this.modalController.dismiss();
                this.data.sendToast("Hiba történt: " + error, "error")
              },
            });
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.data.hideLoading();
          //this.modalController.dismiss();
          this.data.sendToast("Hiba történt: " + error, "error")
        },
      });
  }

  selectChangedAnyanyelv(e) {

  }

}
